module.exports = __webpack_public_path__ + "img/lock-fill.165bb047.svg";